let __stoped = false;

export const scrollLeft = (elem, from, to, duration = 1.0) => {
  stopAnimation();
  let progress = 0;
  let currentPosition = 0;
  let distance = to - from;
  let toLeft = distance >= 0;
  let ease = (p) => {
    return p * (2 - p);
  };

  return new Promise((resolve, reject) => {
    let move = () => {
      progress++;
      currentPosition = distance * ease(progress / (100 * duration)) + from;

      elem.scroll({ left: currentPosition });

      if (inAnimation()) {
        requestAnimationFrame(move);
        return;
      };

      resolve();
    };

    let inAnimation = () => {
      return !__stoped && ((toLeft && currentPosition < to) || (!toLeft && currentPosition > to));
    };

    __stoped = false;
    requestAnimationFrame(move);
  });
};

export const stopAnimation = async () => {
  let stop = async () => {
    __stoped = true;
  };
  return stop();
}
